export const LOCAL_STORAGE_TOKEN_KEY = "agora-auth-token";
export const MANIFEST_URL = "https://agorata.io/tonconnect-manifest.json";
